export const trackByRef = <T>(_index: number, item: T): T => item;

export const trackByIndex = <T>(index: number, _item: T): number => index;
